import * as React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ParamBrandHouse } from "../../../Parameters";
import { useInvoiceAdjustmentsQuery } from "../../../Queries";
import {
   Table,
   TableBody,
   TableCell,
   TableHead,
   TableRow,
   Button,
   Box
} from "@mui/material";
import dayjs from "dayjs";
import { AdjustmentCreateDialog } from "./AdjustmentCreateDialog";

export const AdjustmentsList = () => {
   const { brandHouseId } = useParams<ParamBrandHouse>();
   const [dialogOpen, setDialogOpen] = useState(false);
   
   const { data, refetch } = useInvoiceAdjustmentsQuery({
      variables: {
         brandHouseId
      }
   });

   const adjustments = data?.InvoiceAdjustments || [];

   return (
      <Box>
         <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Button
               variant="contained"
               color="primary"
               onClick={() => setDialogOpen(true)}
            >
               Add Adjustment
            </Button>
         </Box>
         
         <Table>
            <TableHead>
               <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell align="right">Amount</TableCell>
               </TableRow>
            </TableHead>
            <TableBody>
               {adjustments.map((adjustment) => (
                  <TableRow key={adjustment._id}>
                     <TableCell>
                        {dayjs(adjustment.createdAt).format('DD/MM/YYYY')}
                     </TableCell>
                     <TableCell>{adjustment.description}</TableCell>
                     <TableCell 
                        align="right" 
                        sx={{ 
                           color: adjustment.amount < 0 ? 'error.main' : 'text.primary',
                           fontWeight: 'medium'
                        }}
                     >
                        {adjustment.amount.toFixed(2)} DKK
                     </TableCell>
                  </TableRow>
               ))}
               {adjustments.length === 0 && (
                  <TableRow>
                     <TableCell colSpan={3} align="center">
                        No adjustments found
                     </TableCell>
                  </TableRow>
               )}
            </TableBody>
         </Table>
         
         <AdjustmentCreateDialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            onCreated={() => {
               setDialogOpen(false);
               refetch();
            }}
         />
      </Box>
   );
};
